export const SET_DEFAULT_TRANSLATION = "TRANSLATE|SET_DEFAULT_TRANSLATION";
